"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RadioGroupState = /** @class */ (function () {
    function RadioGroupState(state) {
        Object.assign(this, state);
    }
    return RadioGroupState;
}());
exports.default = RadioGroupState;
//# sourceMappingURL=RadioGroupState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/RadioGroupState.js
// module id = 1225
// module chunks = 8